/** @prettier */
const COLLECTOR_PATH = '/ui-collector';
// recorder.js reads the session from window.umami, so it must execute after the tracker
const SCRIPTS = ['eddie-analytics.js', 'recorder.js'];
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Plain string checks, so the fetch wrapper can never throw for other requests
const isCollectorRequest = (input) => {
  const url = String((input && input.url) || input);

  return (
    url.startsWith(`${COLLECTOR_PATH}/`) ||
    url.startsWith(`${window.location.origin}${COLLECTOR_PATH}/`)
  );
};

// Cloudflare rejects requests without its cookies, and the Umami tracker always sends with credentials: 'omit'
const sendCollectorRequestsWithCookies = () => {
  const originalFetch = window.fetch;

  window.fetch = (input, init) => {
    if (isCollectorRequest(input)) {
      return originalFetch.call(window, input, { ...init, credentials: 'same-origin' });
    }

    return originalFetch.call(window, input, init);
  };
};

/**
 * Loads the Umami tracker and session recorder through the HAProxy collector path
 * @param {String} websiteId The Umami website ID of the site
 */
export const load = (websiteId) => {
  if (
    !UUID_PATTERN.test(websiteId) ||
    document.querySelector(`script[src^="${COLLECTOR_PATH}/"]`)
  ) {
    return;
  }

  sendCollectorRequestsWithCookies();

  SCRIPTS.forEach((fileName) => {
    const script = document.createElement('script');

    script.async = false;
    script.src = `${COLLECTOR_PATH}/${fileName}`;
    script.setAttribute('data-website-id', websiteId);
    script.setAttribute('data-host-url', COLLECTOR_PATH);

    document.head.appendChild(script);
  });
};

/**
 * Sends a custom event to Umami, ignored when the tracker is not loaded
 * @param {String} name The name of the event
 * @param {Object} data Any properties to track with the event
 */
export const track = (name, data) => {
  if (typeof window.umami?.track === 'function') {
    window.umami.track(name, data);
  }
};
